export enum UserStatus {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
}

export enum Role {
  ROLE_VENDOR_FRANCHISED = 'ROLE_VENDOR_FRANCHISED',
  ROLE_CASHIER_FRANCHISED = 'ROLE_CASHIER_FRANCHISED',
  ROLE_SUPERVISOR_FRANCHISED = 'ROLE_SUPERVISOR_FRANCHISED',
  ROLE_SUPERVISOR = 'ROLE_SUPERVISOR',
  ROLE_PRICING_FRANCHISED = 'ROLE_PRICING_FRANCHISED',
  NONE = 'NONE',
  ROLE_ADMIN_FRANCHISED = 'ROLE_ADMIN_FRANCHISED',
  ROLE_ADMIN = 'ROLE_ADMIN',
  ROLE_CREDIT_REQUEST_FRANCHISED = 'ROLE_CREDIT_REQUEST_FRANCHISED',
}

export enum RegisterStatus {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
}

export enum DiscountType {
  PRICE = 'PRICE',
  ABSOLUTE = 'ABSOLUTE',
  PERCENTAGE = 'PERCENTAGE',
  NONE = 'NONE',
}

export enum CardType {
  CREDIT = 'CREDIT',
  DEBIT = 'DEBIT',
  AMEX = "AMEX",
  MASTERCARD = "MASTERCARD",
  VISA = "VISA",
  DISCOVER = "DISCOVER",
  DINERS = "DINERS",
  OTRA = "OTRA"
}

export enum PaymentStatus {
  ACTIVE = 'ACTIVE',
  CANCELLED = 'CANCELLED',
}

export enum DocumentType {
  REGULAR = 'REGULAR',
  CANCELLATION = 'CANCELLATION',
  REGULAR_LOAN = 'REGULAR_LOAN',
  CANCELLATION_LOAN = 'CANCELLATION_LOAN',
  SUBSCRIPTION_PAYMENT = 'SUBSCRIPTION_PAYMENT',
  CANCELLATION_SUBSCRIPTION_PAYMENT = 'CANCELLATION_SUBSCRIPTION_PAYMENT',
  CREDIT_PAYMENT = 'CREDIT_PAYMENT',
  GIFTCARD = 'GIFTCARD',
  GIFTCARD_REFUND = 'GIFTCARD_REFUND',
  ADVANCE = 'ADVANCE',
  ADVANCE_REFUND = 'ADVANCE_REFUND',
  ADVANCE_RETURN = 'ADVANCE_RETURN',
  EMIT_CREDIT_NOTE = 'EMIT_CREDIT_NOTE',
  VOID_CREDIT_NOTE = 'VOID_CREDIT_NOT',
}

export enum InitialPaymentType {
  ZE01 = 'ZE01',
  ZE02 = 'ZE02',
  ZH01 = 'ZH01',
  ZH02 = 'ZH02',
  ZT01 = 'ZT01',
  ZT02 = 'ZT02',
  ZT03 = 'ZT03',
  ZT04 = 'ZT04',
  ZT05 = 'ZT05',
  ZT06 = 'ZT06',
  ZT07 = 'ZT07',
  ZT08 = 'ZT08',
  ZT09 = 'ZT09',
  ZT10 = 'ZT10',
  ZT11 = 'ZT11',
  ZT12 = 'ZT12',
  ZT13 = 'ZT13',
  ZT14 = 'ZT14',
  ZT15 = 'ZT15',
  ZT16 = 'ZT16',
  ZT17 = 'ZT17',
  ZT18 = 'ZT18',
  ZD01 = 'ZD01',
  ZTD1 = 'ZTD1',
  ZTD2 = 'ZTD2',
  ZTD3 = 'ZTD3',
  ZTD4 = 'ZTD4',
  ZTC1 = 'ZTC1',
  ZTC2 = 'ZTC2',
  ZTC3 = 'ZTC3',
  ZTC4 = 'ZTC4',
  ZG01 = 'ZG01',
  ZA02 = 'ZA02',
  ZP01 = 'ZP01',
  ZC01 = 'ZC01',
  ZA01 = 'ZA01',
  ZN01 = 'ZN01',
  ZN02 = 'ZN02',
  ZVD1 = 'ZVD1',
  ZR01 = 'ZR01',
  ZR02 = 'ZR02',
  ZR03 = 'ZR03',
  ZPL1 = 'ZPL1',
}

export enum OrderType {
  REGULAR = 'REGULAR',
  CREDIT = 'CREDIT',
  RETURN = 'RETURN',
  QUOTATION = 'QUOTATION',
  CANCELLED = 'CANCELLED',
  REPAIRSHOP = 'REPAIRSHOP',
}

export enum CustomerType {
  CORPORATE = 'CORPORATE',
  RETAIL = 'RETAIL',
  EMPLOYEE = 'EMPLOYEE',
  INTERCOMPANY = 'INTERCOMPANY',
  FRANCHISED = 'FRANCHISED',
}

export enum OrderStatus {
  NONE = '',
  DELETED = 'DELETED',
  INITIAL = 'INITIAL',
  FINAL = 'FINAL',
  INVOICEABLE = 'INVOICEABLE',
  REJECTED = 'REJECTED',
  FINAL_INVOICEABLE = 'INVOICEABLE,REJECTED,FINAL',
  VOIDED = 'VOIDED'
}

export enum OrderProcessingStatus {
  NONE = 'NONE',
  UNAPPROVED = 'UNAPPROVED',
  APPROVED = 'APPROVED',
}

export enum OrderDiscountStatus {
  NONE = 'NONE',
  PENDING = 'PENDING',
  APPROVED = 'APPROVED',
  APPROVED_UNDER_MARGIN = 'APPROVED_UNDER_MARGIN',
  REJECTED = 'REJECTED',
}

export enum ModalDialogType {
  NONE = '',
  PRIMARY = 'modal-primary',
  SUCCESS = 'modal-success',
  WARNING = 'modal-warning',
  DANGER = 'modal-danger',
  INFO = 'modal-info',
}

export enum Personality {
  PERSON = 'PERSON',
  LEGAL_ENTITY = 'LEGAL_ENTITY',
}
/* component pos-create-customer-person */
export const CurrentCountry: string = 'HN';
export const CountryHN: string = 'HN';
export const FiscalIdTypeRTN: string = 'ZHN004';
export const FiscalIdTypeAlwaysShow: Array<String> = ['ZHN002', 'ZHN003'];
export const ParamPhoneMaskHn: string = 'phone-mask-hn';
export const ParamPhoneMaskNoHn: string = 'phone-mask-no-hn';
export const phoneMinimumCharacters: string = 'phone-minimum-characters';
export const CURRENT_NATIONALITY = 'Hondureña';
export const CountrySV = 'SV';
export const CountryCR = 'CR';
export const HN_FISCAL_TYPE_CODE = 'ZHN004';
export const SV_FISCAL_TYPE_CODE = 'ZSV004';
export const CR_FISCAL_TYPE_CODE = 'ZCR004';
export const MIN_LENGTH_HN = 9;
export const DEFAULT_HN_PHONE_CODE = '+(504)';
export const REGEX = {
  email:
    /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,3}))$/,
};
export const PaymentTypeCodeCheck: string = "CH";
export const PaymentTypeCodeCard: string = "CARD";

export enum ServiceType {
  //EXTRA_WARRANTY = '01',
  //INTALLATION = '02',
  //TOTAL_PROTECTION = '03',
  //TECHNICAL_ASSISTANCE = '04',
  //PREVENTIVE_MANTEINANCE = '05',
  //UNLIMITED_LABOR = '06',
  //PLATE = '07',
  //TOP_UP = '08',
  //REPRINT_INVOICE = '09',
  //OTHER = '10',
  EXTRA_WARRANTY = "EXTRA_WARRANTY",
  INTALLATION = "INTALLATION",
  TOTAL_PROTECTION = "TOTAL_PROTECTION",
  TECHNICAL_ASSISTANCE = "TECHNICAL_ASSISTANCE",
  PREVENTIVE_MANTEINANCE = "PREVENTIVE_MANTEINANCE",
  UNLIMITED_LABOR = "UNLIMITED_LABOR",
  PLATE = "PLATE",
  TOP_UP = "TOP_UP",
  REPRINT_INVOICE = "REPRINT_INVOICE",
  OTHER = "OTHER",
}

export enum RoleType {
  TR0100 = 'TR0100',
  TR0200 = 'TR0200',
}

export enum PrintType {
  ORIGINAL = 'ORIGINAL',
  COPY = 'COPY',
  REGISTRATION = 'REGISTRATION',
}

export enum OriginLoan {
  POS = 'POS',
  SAP = 'SAP',
}

export enum OrderAttachmentType {
  FISCALID = 'FISCALID',
  RTNFISCALID = 'RTNFISCALID',
  IP800 = 'IP800',
  PROMISSORY_NOTE = 'PROMISSORY_NOTE',
  DOMAIN_TRADITION = 'DOMAIN_TRADITION',
  PROOF_OF_PAYMENT = 'PROOF_OF_PAYMENT',
  PURCHASE_ORDER = 'PURCHASE_ORDER',
}

export enum OnBaseCatalogueType {
  HOME = 'HOME_TYPE',
  REASON_NO_ENTER_CREDIT_REQUEST = 'REASON_NO_ENTER_CREDIT_REQUEST',
  MARITALSTATUS = 'MARITAL_STATUS',
  NATURALRELATION = "NATURAL_RELATION"
  // TODO:falta agregar los demas tipos de catalogos
}

export enum LimitRulesType {
  BURO = 'ILP-BURO',
  // TODO:falta agregar los demas reglas
}

export enum PromotionType {
  GENERAL = 'GENERAL',
  DIRECTED = 'DIRECTED',
}

export enum PromotionPaymentType {
  RETAIL = 'RETAIL',
  CREDIT = 'CREDIT',
  EITHER = 'EITHER',
}

export enum LinkCategory {
  AND = 'AND',
  OR = 'OR',
}

export enum ScaleType {
  FROM = 'FROM',
  UP_TO = 'UP_TO',
  EQUAL = 'EQUAL',
}

export enum RepairshopOrderType {
  ZFFT = 'ZFFT',
  ZFAU = 'ZFAU',
  ZFST = 'ZFST',
  S1 = 'S1',
  S2 = 'S2',
  BOTH = 'BOTH',
  RETAIL = 'RETAIL',
}

export enum VoidOrderOperationType {
  VOID = 'VOID',
  CANCEL = 'CANCEL',
  RETURN = 'RETURN',
}

export enum OrderConditionsType {
  CREDIT = 'Credit',
  CREDIT_30_DAYS = 'Credit30Days',
  CREDIT_WITH_PAYMENT_RESPONSIBLE = 'CreditWithPaymentResponsible',
  REFERENCE = 'references',
  PREAPPROVE = 'PreAprove',
  CASH = "Cash"

}
export enum LoanClass {
  CLASS_FOR_PERSON = '001',
  CLASS_FOR_EMPLOYEE = '002',
  CLASS_FOR_COVENANT = '005',
  CLASS_FOR_THIRTY_DAYS = '008',
}

export enum CustomerCreditStatus {
  ACTIVE = 'ACT',
  POTENTIAL = 'POT',
  INACTIVE = 'INA',
  COVENANT = 'CVN',
}

export enum RepairshopOrderSubType {
  UNSPECIFIED = 'BOTH',
  TIENDA = 'RETAIL',
  TALLER = 'ZFST',
}

export enum CreditStatus {
  NO_STATUS = 'NO_STATUS',
  APPROVED = 'APPROVED',
  REJECTED = 'REJECTED',
  CONTROL_TABLE = 'CONTROL_TABLE',
  TELEPHONE_INVESTIGATION = 'TELEPHONE_INVESTIGATION',
  HOME_DOMESTIC_INVESTIGATION = 'HOME_DOMESTIC_INVESTIGATION',
  WORK_DOMESTIC_INVESTIGATION = 'WORK_DOMESTIC_INVESTIGATION',
  HUMAN_RESOURCES = 'HUMAN_RESOURCES',
  ANALISYS_AND_APPROVAL = 'ANALISYS_AND_APPROVAL',
  WITH_REQUIREMENTS = 'WITH_REQUIREMENTS',
  REPROGRAMMING_IT = 'REPROGRAMMING_IT',
  REPROGRAMMING_HOUSE_ID = 'REPROGRAMMING_HOUSE_ID',
  REPROGRAMMING_WORK_ID = 'REPROGRAMMING_WORK_ID',
}

export enum CreditProcessStatus {
  PROCESSED = 'PROCESSED',
  FAILED = 'FAILED',
  UNPROCESSED = 'UNPROCESSED',
  DRAFT = 'DRAFT',
  PROCESSING = 'PROCESSING',
}

export enum TicketProcessingStatus {
  FAILED = 'FAILED',
  PROCESSED = 'PROCESSED',
  UNPROCESSED = 'UNPROCESSED',
  PROCESSING = 'PROCESSING',

}

export enum CreditPlansCodes {
  PAC = '0006',
  CVN = '0008',
  NOR = '0005',
  JUR = '0010',
  THIRTYDAYS = '0009',
}

export enum AdvanceReturnType {
  ADVANCE_REQUEST_REFUND = 'ADVANCE_REQUEST_REFUND',
  ADVANCE_REFUND = 'ADVANCE_REFUND',
}

export enum AutomaticClosingRegisterStatus {
  OPEN = 'OPEN',
  CLOSED = 'CLOSED',
}

export enum OrderConditions {
  UNTIL_30_DAYS_FRANCHISED = 1,
  MORE_THAN_30_DAYS_FRANCHISED = 2,
  FINAL_CUSTOMER_CREDIT = 3,
  CASH_BILLLING = 4,
  CREDIT_QUOTATION = 5,
  CREDIT_QUOTATION_PRE = 6,
}
export const DATE_PATTERN = 'YYYYMMDD';
export const TIMESTAMP_PATTERN = "yyyyMMddHHmmss";
export const FULL_DATE_PATTERN = "yyyy-MM-dd'T'HH:mm:ss";
export const NO_FISCAL_REGISTER_PARAM_CODE = 'no-fiscal-register-code';

export enum TicketFilesTitles {
  IDENTITY = 'Identidad',
  RTN = 'RTN',
  IP_800 = 'IP-800',
  THIRD_PARTY_AUTORIZATION = 'Autorización a terceros',
  ENROLLMENT_REJECT = 'Rechazo de matrícula',
  DOMAIN_TRADITION_1 = 'Tradición de Dominio 1',
  DOMAIN_TRADITION_2 = 'Tradición de Dominio 2',
  ROAD_SKETCH = 'Croquis',
  INVOICE = 'Factura',
  DELIVERY_FORMAT = 'Formato de Entrega'
}

export const TICKET_TYPE_ZMA5 = 'ZMA5';
export const TICKET_TYPE_ZMA5_DESCRIPTION = 'Matricula de motocicleta';
export const FEATUREPRODUCTREQUIREREGISTRATION = 'matricula1';

export enum DigitalSignatureRequestStatus {
  UNPROCESSED = 'UNPROCESSED',
  PROCESSED = 'PROCESSED',
  INITIAL_REQUEST = 'INITIAL_REQUEST',
  UPLOAD_ATTACHMENT = 'UPLOAD_ATTACHMENT',
  UPLOAD_INVOICES = 'UPLOAD_INVOICES',
  UPLOAD_LOAN = 'UPLOAD_LOAN',
  FAILED = 'FAILED',
  SIGNATURE_FAILED = 'SIGNATURE_FAILED',
  WAITING_FOR_CLIENT = 'WAITING_FOR_CLIENT',
  DONE = 'DONE',
  REJECTED = 'REJECTED'

}

export enum DigitalSignatureRequestStatusInOrder {
  NA = 'NA',
  UNPROCESSED = 'UNPROCESSED',
  PROCESSING = 'PROCESSING',
  FAILED = 'FAILED',
  WAITING_FOR_CLIENT = 'WAITING_FOR_CLIENT',
  DONE = 'DONE',
  REJECTED = 'REJECTED'
}

export enum OrderCondition {
  CREDIT = 'credito',
  CASH = 'contado',
}
export const CURRENCY_HNL = 'HNL';
export const CURRENCY_USD = 'USD';

export const PAYMENTTYPESAVAILABLEFRANCHISED =
  'payment-types-available-franchised';

export enum OrderTransactionStatus {
  NEW = 'NEW',
  INVOICES = 'INVOICES',
  LOANS = 'LOANS',
  NOTE_CHARGE = 'NOTE_CHARGE',
  NOTE_CHARGE_PAYMENT = 'NOTE_CHARGE_PAYMENT',
  PAYMENTS = 'PAYMENTS',
  DOCUMENT_ATTACHMENTS = 'DOCUMENT_ATTACHMENTS',
  DOWNPAYMENT_RECEIPT = 'DOWNPAYMENT_RECEIPT',
  FINISHED = 'FINISHED',
  NO_STATUS = 'NO_STATUS',
}

export enum DomainTraditionReportType {
  PERSON_TO_PERSON = 'PERSON_TO_PERSON',
  PERSON_TO_JURIDIC = 'PERSON_TO_JURIDIC',
  JURIDIC_TO_PERSON = 'JURIDIC_TO_PERSON',
  JURIDIC_TO_JURIDIC = 'JURIDIC_TO_JURIDIC',
}

export enum BiometryType {
  PHOTO = 'PHOTO',
  FINGERPRINT = 'FINGERPRINT',
}

export enum BiometryHand {
  LEFT = 'LEFT',
  RIGHT = 'RIGHT',
}

export enum BiometryFinger {
  THUMB = 'THUMB',
  INDEX = 'INDEX',
  MIDDLE = 'MIDDLE',
  RING = 'RING',
  LITTLE = 'LITTLE',
}

export enum UserAndSellerShowMode {
  USERS = 'USERS',
  SELLERS = 'SELLERS',
}

export enum SerialType {
  LIST = "LIST", MANUAL = "MANUAL"
}

export const EXTRA_WARRANTY_SERVICE_TYPE = 'EXTRA_WARRANTY';
export const CHANGE_CREDIT_CONDITIONS_PRIVILEGE_CODE = 'permit_modify_credit_conditions';

export const incomeTypes: Array<{ code: string, customerType: string, description: string }> = [
  { code: 'Z000', customerType: "PERSON", description: 'ASALARIADO' },
  { code: 'Z001', customerType: "PERSON", description: 'INDEPENDIENTE' },
  { code: 'Z002', customerType: "PERSON", description: 'REMESAS' },
  { code: 'Z003', customerType: "EMPLOYEE", description: 'ASALARIADO' },
  { code: 'Z004', customerType: "AGREEMENT", description: 'ASALARIADO' },
  { code: 'Z005', customerType: "PERSON", description: 'OTROS INGRESOS' },
  { code: 'Z006', customerType: "FASTTRACK", description: "ASALARIADO" },
  { code: 'Z007', customerType: "FASTTRACK", description: "INDEPENDIENTE" },
  { code: 'Z002', customerType: "FASTTRACK", description: 'REMESAS' },
  { code: 'Z005', customerType: "FASTTRACK", description: 'OTROS INGRESOS' },
];

export const incomeOrigins = [
  // { key: "NACIONAL", value: "Nacional" },
  { key: "INTERNACIONAL", value: "Internacional" },
];

export const otherIncomeTypes = [
  { key: "ALQUILERES", value: "Alquileres" },
  { key: "JUBILADO", value: "Jubilado" },
  { key: "OTROS", value: "Otros" },
]

export enum EquipmentStatus {
  VIGENTE = "VIGENTE", DEVOLUCION = "DEVOLUCION"
}

export enum ReturnPaymentType {
  CASH = "CASH", CREDIT_NOTE = "CREDIT_NOTE", NONE = ""
}

export enum RecollectionType {
  QUOTAS_PAYMENT = `1`,
  PAY_OFF = `2`,
  CONDONATION = `3`,
  REPAIRSHOP_INVOICE = `4`,
  OTHERS = `5`,
  NONE = `-1`
}

export enum PsychometricEvaluationStatus {
  ERROR = "ERROR", IN_PROCESS = "IN_PROCESS", PENDING = "PENDING", FINISHED = "FINISHED"
}

export enum RiskOrderType {
  LOCK_BY_SERVICE = "LOCK_BY_SERVICE",
  UNLOCK_BY_USER = "UNLOCK_BY_USER",
  UNLOCK_BY_ERROR = "UNLOCK_BY_ERROR",
  UNLOCK_BY_SERVICE = "UNLOCK_BY_SERVICE"
}

// for biometry on credit request
export const ParamListOfBranchesNotValidateBiometryOnCreditRequest = "list-of-branches-not-validate-biometry-on-credit-request";
export const nameOfDocumentToTakePictureOnCreditRequests = `Toma de fotografía "in situ"`;
export const PARAM_SHORTFORMCREDITPLANCODES = "short-form-credit-plan-codes";

// for biometry on invoices
export const ParamListOfBranchesNotValidateBiometryOnInvoice = `list-of-branches-not-validate-biometry-on-credit-orders`;
export const ParamListOfBranchesNotValidateBiometryOnCashLoans = `list-of-branches-not-validate-biometry-on-cash-loans`;

export enum ReplicateInformationStatus {
  UNPROCESSED = "UNPROCESSED", PROCESSING = "PROCESSING", PROCESSED = "PROCESSED", FAILED = "FAILED", SKIPED = "SKIPED", DELETED = "DELETED", SENDFORCSV = "SENDFORCSV"
}

export enum ReplicateInformationTo {
  SALESFORCE = "SALESFORCE", ADOBE_CDP = "ADOBE_CDP", ALL = "ALL"
}
export enum ReplicateInformationCollection {
  QUOTATION = "QUOTATION", ORDER = "ORDER", INVOICE = "INVOICE", PREAPPROVE = "PREAPPROVE", CREATECUSTOMER = "CREATECUSTOMER", TICKET = "TICKET", CREDITREQUEST = "CREDITREQUEST"
}
export enum ReplicateInformationCollectionBranches {
  ALL = "ALL", ONLY_BRACHES = "ONLY_BRACHES"
}

export enum PersonalLoanType {
  CASH = "CASH", PERSONAL_LOAN = "PERSONAL_LOAN", CREDIT_LINE = "CREDIT_LINE"
}
export enum VerifyCustomerValidateTokenType {
  PHONE = "PHONE", EMAIL = "EMAIL"
}

export const PARAM_TO_KNOW_BRANCHED_SKIP_VERIFYCATION_VALKYRIA = 'verification-valkyria-skipped-branches';

export enum TenderType {
  BILL, COIN
}

export enum AdvanceType {
  SHOP = "SHOP", WEDDING = "WEDDING"
}

export const FROMUPDATECUSTOMER = 'alertUpdateCustomer';

export enum OrderChannel {
  POS = "POS", WEB = "WEB"
}
export enum OrderChannelType {
  REGULAR = "REGULAR", WEDDING = "WEDDING"
}

export enum ReimbursementOperation {
  PAYMENT = "PAYMENT", VOID = "VOID"
}

export enum FiscalEmissionPointType {
  POS = "POS", SAP = "SAP", MIX = "MIX"
}

export enum DigitalSignatureType {
  SIGNERS = "SIGNERS", INPERSONSIGNERS = "INPERSONSIGNERS", SIGNERS_EMBEDDED = "SIGNERS_EMBEDDED"
}

export enum DocumentsByEmailType {
  INVOICE = "INVOICE", QUOTATION = "QUOTATION"
}

export enum ReportsSendToEmail {
  INVOICE = "INVOICE", RECEIPT = "RECEIPT", EXTRA_WARRANTY = "EXTRA_WARRANTY", QUOTATION = "QUOTATION"
}

export enum OrderCheckedStatus {
  PENDING = "PENDING", PARTIAL_CHECK = "PARTIAL_CHECK", CHECKED = "CHECKED"
}

export enum BiometryDeviceMake {
  ZKTECO = 'ZKTECO',
  SECUGEN = 'SECUGEN'
}

export enum PeriodStatus {
  PENDING = "PENDING"
}

export const ID_SECOND_IDENTICATION_GROUP_DOCUMENT = '105';
export enum TokenProcess {
  CREDITORDER = 'CREDITORDER', CASHLOAN = "CASHLOAN"
}

export enum BiometryLockedStatus {
  UNLOCKED_BY_CRED_MANAGER = "UNLOCKED_BY_CRED_MANAGER", LOCKED_BY_SYSTEM = "LOCKED_BY_SYSTEM", UNLOCKED_BY_ERROR = "UNLOCKED_BY_ERROR", LOCKED_BY_CRED_MANAGER = "LOCKED_BY_CRED_MANAGER", NONE = ""
}
